import TextField, { TextFieldProps } from '@mui/material/TextField'
import { useIntl } from 'react-intl'
import { StateControl } from '.'

export type TextSearchFieldProps = {
  label?: string
  stateControl: StateControl<string>
} & TextFieldProps

const TextSearchField = ({
  label,
  stateControl,
  ...textFieldProps
}: TextSearchFieldProps) => {
  const intl = useIntl()
  const [value, setValue] = stateControl

  return (
    <TextField
      size="small"
      sx={{
        width: '100%',
      }}
      value={value}
      label={label ?? intl.formatMessage({ id: 'common.actions.search' })}
      type="search"
      onChange={(event) => {
        setValue(event.target.value)
      }}
      {...textFieldProps}
    />
  )
}

export default TextSearchField
